// extracted by mini-css-extract-plugin
export var alignCenter = "_b2-d";
export var bannerShown = "_b2-6";
export var buttonContent = "_b2-0";
export var cardList = "_b2-1";
export var centerContent = "_b2-2";
export var chevron = "_b2-3";
export var closePanelButton = "_b2-k";
export var conversationContextContainer = "_b2-l";
export var conversationDetailContainer = "_b2-4";
export var detailWrapper = "_b2-7";
export var dropdownButton = "_b2-e";
export var dropdownTitle = "_b2-9";
export var fullHeight = "_b2-5";
export var hidden = "_b2-a";
export var icon = "_b2-b";
export var mergeSuggestionWrapper = "_b2-m";
export var panel = "_b2-i";
export var portalButtonsWrapper = "_b2-c";
export var right = "_b2-j";
export var tableSummaryContainer = "_b2-8";
export var tableSummaryHeader = "_b2-g";
export var threeDotsButton = "_b2-f";
export var wide = "_b2-h";